import { FormatNumberWithCommas } from "../../../../../../shared/scripts/number-functions";
import { SetActiveTab } from "../../../../../../shared/scripts/tab-utilities";
import { RenderNullableNumberWithSeparators, RenderProgressValue } from "../../../../../../shared/scripts/table-functions";
import { ISiteInfo } from "../../../scripts/data-completeness.page";
import { VisitsController } from "../scripts/visits.controller";
import { VisitsDialog } from "../scripts/visits.dialog";
import { VisitsDatatableEntry } from "./visits-datatable.entities";


export class VisitsDatatableView {

    selectedGrouping: string; //none, visit, site

    tableNone: any; tableNoneId: string = "visit-datatable-none";
    tableByVisit: any; tableVisitId: string = "visit-datatable-byvisit";
    tableBySite: any; tableSiteId: string = "visit-datatable-bysite";

    constructor() {
        this.selectedGrouping = "none";

        this.tableNone = this.initializeTableWithScroller(this.tableNoneId, this.tableNoneId + "_wrapper");
        this.tableByVisit = this.initializeTable(this.tableVisitId, this.tableVisitId + "_wrapper");
        this.tableBySite = this.initializeTable(this.tableSiteId, this.tableSiteId + "_wrapper");

        this.initializeDialog([this.tableNoneId, this.tableVisitId, this.tableSiteId]);

        this.setupCsvExportButton();
    }

    private setupCsvExportButton(): void {
        const exportButton = document.getElementById("export-csv-btn-visit");

        if (exportButton) {
            exportButton.addEventListener("click", () => {
                this.exportCsv();
            });
        }
    }

    private exportCsv(): void {
        if (this.selectedGrouping === "none") {
            this.tableNone.button('.buttons-csv').trigger();
        } else if (this.selectedGrouping === "visit") {
            this.tableByVisit.button('.buttons-csv').trigger();
        } else if (this.selectedGrouping === "site") {
            this.tableBySite.button('.buttons-csv').trigger();
        }
    }


    SetView(newView: string): void {

        //console.log(newView);

        if (!newView.startsWith("visit-datatable")) { return; }

        if (newView.includes("none")) { this.selectedGrouping = "none"; }
        else if (newView.includes("byvisit")) { this.selectedGrouping = "visit"; }
        else if (newView.includes("bysite")) { this.selectedGrouping = "site"; }

        if (this.selectedGrouping == "none") { SetActiveTab("visit-datatable-tabs", "content-visit-datatable-none"); this.tableNone.columns.adjust(); }
        else if (this.selectedGrouping == "visit") { SetActiveTab("visit-datatable-tabs", "content-visit-datatable-byvisit"); this.tableByVisit.columns.adjust(); }
        else if (this.selectedGrouping == "site") { SetActiveTab("visit-datatable-tabs", "content-visit-datatable-bysite"); this.tableBySite.columns.adjust(); }
    }

    UpdateData(tableEntriesNone: VisitsDatatableEntry[], tableEntriesByVisit: VisitsDatatableEntry[], tableEntriesBySite: VisitsDatatableEntry[]): void {
        this.tableNone.clear();
        this.tableByVisit.clear();
        this.tableBySite.clear();

        this.tableNone.rows.add(tableEntriesNone).draw();
        this.tableByVisit.rows.add(tableEntriesByVisit).draw();
        this.tableBySite.rows.add(tableEntriesBySite).draw();

        //this.setCountFoundLabel(milestonesBySite.length);
    }

    private initializeTable(tableId: string, tableWrapperId: string): any {

        let dataTable: any = $('#' + tableId).DataTable({
            "dom": 'lrtip',
            autoWidth: true,
            info: false,
            paging: false,
            //pagingType: 'simple',
            //pageLength: 50,
            search: false,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 4
            },
            columns: [
                { data: "Study", title: "Platform", className: "text-left font-size12 nowrap" },
                { data: "Appendix", title: "Trial", className: "text-left font-size12 nowrap" },
                { data: "SiteNumber", title: "Site", className: "text-left font-size12 nowrap" },
                { data: "Visit", title: "Visit", className: "text-left font-size12 nowrap" },
                { data: "PotentialVisits", title: "Potential<br>Visits", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators },
                { data: "ExpectedVisits", title: "Expected<br>Visits", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators },
                { data: "Completed.0", title: "Completed<br>Visits", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators, defaultContent: '', visible: false },
                { data: "Completed.1", title: "Percent<br>Completed", className: "text-center font-size12 nowrap gray font-underline clickable-completed", render: RenderProgressValue, defaultContent: '' },
                { data: "Overdue.0", title: "Overdue<br>Visits", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators, defaultContent: '', visible: false },
                { data: "Overdue.1", title: "Percent<br>Overdue", className: "text-center font-size12 nowrap gray font-underline clickable-overdue", render: RenderProgressValue, defaultContent: '' },
                { data: "NotDone.0", title: "Not Done<br>Visits", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators, defaultContent: '', visible: false },
                { data: "NotDone.1", title: "Percent<br>Not Done", className: "text-center font-size12 nowrap gray font-underline clickable-notdone", render: RenderProgressValue, defaultContent: '' },
                { data: "DiscPrior.0", title: "Disc. Prior<br>Visits", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators, defaultContent: '', visible: false },
                { data: "DiscPrior.1", title: "Percent<br>Disc. Prior", className: "text-center font-size12 nowrap gray font-underline clickable-discprior", render: RenderProgressValue, defaultContent: '' },
                { data: "NotYetDue", title: "Not Yet Due<br>Visits", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators, defaultContent: '' },
                { data: "Site", title: "Site Name", className: "text-left font-size10 nowrap", visible: false },
            ],
            buttons: [
                {
                    extend: 'csv',
                    className: "btn btn-secondary",
                    text: '<i class="fas fa-file-download"></i>',
                    charset: 'utf-8',
                    title: "RECOVER-CT Visits Export",
                }
            ],
            createdRow: (row, data: any, index) => {
                //cell formatting on percentages
                if (data.Completed[1] != undefined) { this.setCellPercentValue(row, 'td:eq(6)', this.getCellColorByValue("Completed", data.Completed[1]), data.Completed[0]); }
                if (data.Overdue[1] != undefined) { this.setCellPercentValue(row, 'td:eq(7)', this.getCellColorByValue("Overdue", data.Overdue[1]), data.Overdue[0]); }
                if (data.NotDone[1] != undefined) { this.setCellPercentValue(row, 'td:eq(8)', this.getCellColorByValue("NotDone", data.NotDone[1]), data.NotDone[0]); }
                if (data.DiscPrior[1] != undefined) { this.setCellPercentValue(row, 'td:eq(9)', this.getCellColorByValue("DiscPrior", data.DiscPrior[1]), data.DiscPrior[0]); }

                //tooltip config for percentages and site number
                //$(row).attr('title', data.Site);
                //$(row).find('td').each(function (index, td) {
                //    $(td).attr('data-toggle', 'tooltip');
                //    $(td).attr('data-placement', 'top');
                //});
            }
            //order: [[1, 'asc'], [7, 'asc']],
        });

        dataTable.on('column-visibility.dt', function () {
            $('[data-toggle="tooltip"]').tooltip()
        });
        $('[data-toggle="tooltip"]').tooltip()

        //$("#" + tableWrapperId + " .top-controls").addClass('row mx-0');

        //$("#" + tableWrapperId + " .search-bar").addClass('col-12 col-md-3');

        //$("#" + tableWrapperId + " .spacer").addClass('col-12 col-md-3');
        //$("#" + tableWrapperId + " .count-found").addClass('col-12 col-md-3 d-flex justify-content-end vertical-align-middle align-self-end mt-2 pr-0');
        //<span id="people-found-count" class="font-italic font-size12" > </span>
        //$("#" + tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"><span id=\"' + tableId + '-found-count\"></span></div>');
        //$("#" + tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"></div>');

        //$('#' + tableId).on('search.dt', (e, settings) => {
        //    this.setCountFoundLabel(tableId, dataTable.rows({ search: 'applied' }).count());
        //});

        return dataTable;
    }


    private initializeTableWithScroller(tableId: string, tableWrapperId: string): any {

        let dataTable: any = $('#' + tableId).DataTable({
            "dom": 'lrtip',
            autoWidth: true,
            info: false,
            paging: true,
            //pagingType: 'simple',
            //pageLength: 50,
            search: false,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            scroller: {
                loadingIndicator: true,
                displayBuffer: 50,
            },
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 4
            },
            columns: [
                { data: "Study", title: "Platform", className: "text-left font-size12 nowrap" },
                { data: "Appendix", title: "Trial", className: "text-left font-size12 nowrap" },
                { data: "SiteNumber", title: "Site", className: "text-left font-size12 nowrap" },
                { data: "Visit", title: "Visit", className: "text-left font-size12 nowrap" },
                { data: "PotentialVisits", title: "Potential<br>Visits", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators },
                { data: "ExpectedVisits", title: "Expected<br>Visits", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators },
                { data: "Completed.0", title: "Completed<br>Visits", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators, defaultContent: '', visible: false },
                { data: "Completed.1", title: "Percent<br>Completed", className: "text-center font-size12 nowrap gray font-underline clickable-completed", render: RenderProgressValue, defaultContent: '' },
                { data: "Overdue.0", title: "Overdue<br>Visits", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators, defaultContent: '', visible: false },
                { data: "Overdue.1", title: "Percent<br>Overdue", className: "text-center font-size12 nowrap gray font-underline clickable-overdue", render: RenderProgressValue, defaultContent: '' },
                { data: "NotDone.0", title: "Not Done<br>Visits", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators, defaultContent: '', visible: false },
                { data: "NotDone.1", title: "Percent<br>Not Done", className: "text-center font-size12 nowrap gray font-underline clickable-notdone", render: RenderProgressValue, defaultContent: '' },
                { data: "DiscPrior.0", title: "Disc. Prior<br>Visits", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators, defaultContent: '', visible: false },
                { data: "DiscPrior.1", title: "Percent<br>Disc. Prior", className: "text-center font-size12 nowrap gray font-underline clickable-discprior", render: RenderProgressValue, defaultContent: '' },
                { data: "NotYetDue", title: "Not Yet Due<br>Visits", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators, defaultContent: '' },
                { data: "Site", title: "Site Name", className: "text-left font-size10 nowrap", visible: false },
            ],
            buttons: [
                {
                    extend: 'csv',
                    className: "btn btn-secondary",
                    text: '<i class="fas fa-file-download"></i>',
                    charset: 'utf-8',
                    title: "RECOVER-CT Visits Export",
                }
            ],
            createdRow: (row, data: any, index) => {
                //cell formatting on percentages
                if (data.Completed[1] != undefined) { this.setCellPercentValue(row, 'td:eq(6)', this.getCellColorByValue("Completed", data.Completed[1]), data.Completed[0]); }
                if (data.Overdue[1] != undefined) { this.setCellPercentValue(row, 'td:eq(7)', this.getCellColorByValue("Overdue", data.Overdue[1]), data.Overdue[0]); }
                if (data.NotDone[1] != undefined) { this.setCellPercentValue(row, 'td:eq(8)', this.getCellColorByValue("NotDone", data.NotDone[1]), data.NotDone[0]); }
                if (data.DiscPrior[1] != undefined) { this.setCellPercentValue(row, 'td:eq(9)', this.getCellColorByValue("DiscPrior", data.DiscPrior[1]), data.DiscPrior[0]); }

                //tooltip config for percentages and site number
                //$(row).attr('title', data.Site);
                //$(row).find('td').each(function (index, td) {
                //    $(td).attr('data-toggle', 'tooltip');
                //    $(td).attr('data-placement', 'top');
                //});
            }
            //order: [[1, 'asc'], [7, 'asc']],
        });

        dataTable.on('column-visibility.dt', function () {
            $('[data-toggle="tooltip"]').tooltip()
        });
        $('[data-toggle="tooltip"]').tooltip()

        //$("#" + tableWrapperId + " .top-controls").addClass('row mx-0');

        //$("#" + tableWrapperId + " .search-bar").addClass('col-12 col-md-3');

        //$("#" + tableWrapperId + " .spacer").addClass('col-12 col-md-3');
        //$("#" + tableWrapperId + " .count-found").addClass('col-12 col-md-3 d-flex justify-content-end vertical-align-middle align-self-end mt-2 pr-0');
        //<span id="people-found-count" class="font-italic font-size12" > </span>
        //$("#" + tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"><span id=\"' + tableId + '-found-count\"></span></div>');
        //$("#" + tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"></div>');

        //$('#' + tableId).on('search.dt', (e, settings) => {
        //    this.setCountFoundLabel(tableId, dataTable.rows({ search: 'applied' }).count());
        //});

        return dataTable;
    }

    private getCellColorByValue(dataElement: string, value: number): string {
        if (dataElement == "Completed") {
            if (value >= 0.85) return "#7fb87f";
            else if (value >= 0.65) return "#FCE77D";
            else return "#F07D7D";
        }
        else if (dataElement == "Overdue" || dataElement == "NotDone") {
            if (value < 0.10) return "#7fb87f";
            else if (value <= 0.20) return "#FCE77D";
            else return "#F07D7D";
        }
        else if (dataElement == "DiscPrior") {
            if (value < 0.10) return "#7fb87f";
            else if (value <= 0.20) return "#FCE77D";
            else return "#F07D7D";
        }
    }

    private initializeDialog(tableIds: string[]): void {

        tableIds.forEach((tableId: string) => {
            $('#' + tableId).on('click', 'td.clickable-completed', function () {
                var row = $('#' + tableId).DataTable().row(this).data();
                VisitsDialog.ShowDialog(row.CompletedVisits);
            });
            $('#' + tableId).on('click', 'td.clickable-overdue', function () {
                var row = $('#' + tableId).DataTable().row(this).data();
                VisitsDialog.ShowDialog(row.OverdueVisits);
            });
            $('#' + tableId).on('click', 'td.clickable-notdone', function () {
                var row = $('#' + tableId).DataTable().row(this).data();
                VisitsDialog.ShowDialog(row.NotDoneVisits);
            });
            $('#' + tableId).on('click', 'td.clickable-discprior', function () {
                var row = $('#' + tableId).DataTable().row(this).data();
                VisitsDialog.ShowDialog(row.DiscPriorVisits);
            });
        });
    }

    private setCellPercentValue(row: any, cell: string, color: string, count: number): void {
        $(cell, row).css('background-color', color);
        $(cell, row).attr('title', 'n = ' + count);
        $(cell, row).attr('data-toggle', 'tooltip');
        $(cell, row).attr('data-placement', 'top');
    }

    /*exportTable(): void {

        let tableId: string = undefined;
        if (this.selectedGrouping == "none") { tableId = this.tableNoneId; }
        else if (this.selectedGrouping == "byvisit") { tableId = this.tableVisitId; }
        else if (this.selectedGrouping == "bysite") { tableId = this.tableSiteId; }
        if (tableId != undefined) {
            let table = $("#" + this.tableNoneId).DataTable();
            (<any>table).button(0).trigger();            
        }
    }*/

    private setCountFoundLabel(tableId: string, count: number): void {

        switch (count) {
            case 0: $('#' + tableId + '-found-count').text("No Records Found"); break;
            case 1: $('#' + tableId + '-found-count').text("1 Record Found"); break;
            default: $('#' + tableId + '-found-count').text(FormatNumberWithCommas(count + "") + " Records Found");
        }
    }

    private refresh(): void {
        //this.dataTable.columns.adjust();
        //this.tableColumnController.refresh();
    }

    private clearSearchBar(): void {
        //this.dataTable.search('').draw();
    }
}